import { Routes, Route, Navigate } from "react-router";
import App from "./App";
import AuthPage from "./pages/AuthPage";
import Assistant from "./components/assistant/Assistant";
import Users from "./pages/Users";
import Responses from "./pages/Responses";
import Documents from "./pages/Documents";
import Settings from "./pages/Settings";
import RoleRestrictedRoute from "./roleRestrictedRoute";

const Router = () => {
  return (
    <Routes>
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/" element={<App />}>
        <Route
          index
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin"]}>
              {(role) => (
                <Navigate
                  to={role === "member" ? "/assistant" : "/documents"}
                  replace
                />
              )}
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="assistant"
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin"]}>
              <Assistant key={window.location.search} />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="documents"
          element={
            <RoleRestrictedRoute allowedRoles={["admin"]}>
              <Documents />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="users"
          element={
            <RoleRestrictedRoute allowedRoles={["admin"]}>
              <Users />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="answers"
          element={
            <RoleRestrictedRoute allowedRoles={["admin"]}>
              <Responses />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <RoleRestrictedRoute allowedRoles={["admin"]}>
              <Settings />
            </RoleRestrictedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default Router;
